import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import "./CreateFeeds.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Input,
  LoadingButton,
  TextArea,
} from "../../../Components/header/form";
import {
  imageHandler,
  multipleImageHandler,
} from "../../../utils/imageHandler";
import { edit_icon, img_placehlder, upload_cover } from "../../../assets";
import multipartDataHelper, {
  printFormData,
} from "../../../utils/sendMultipartDataHelper";
import { toastMessage } from "../../../utils/toastMessage";
import { createFeedApi } from "../../../services/feeds";
import Slider from "react-slick";
import { RxCross2 } from "react-icons/rx";
import { CiNoWaitingSign } from "react-icons/ci";
import { removeLeadingSpace } from "../../../utils/regexValidation";
import { FaArrowLeft } from "react-icons/fa";

const CreateFeeds = () => {
  const { groupId } = useParams();
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    _group: groupId,
    title: "",
    description: "",
  });
  const [image, setImage] = useState([]);
  const navigate = useNavigate();
  const [buttonDisabledButton, setDisabledButton] = useState(true)
  // console.log('image.length', image.length)
  //----------handle-on-change-----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: removeLeadingSpace(value) });
  };
  // ------------- validation------------
  const isFormComplete = () => {
    const requiredFields = ["title", "description"];
    const isAllFilled = requiredFields.every((field) => String(inputData[field] || ""));
    return isAllFilled;
  };
  // console.log('inputData edit', inputData)
  useEffect(() => {
    setDisabledButton(!isFormComplete());
  }, [inputData]);
  //------------remove-image--------------
  const removeImageHandler = (_id) => {
    const filteredImages = image?.filter((img) => img._id !== _id);
    setImage(filteredImages);
  };

  //------------create-feed-handle-API--------------
  const createFeedHandler = async () => {
    // if (!Array.isArray(image) || image.length === 0) {
    //   return toastMessage("Please upload a cover image", "error", "coverImageUpdateSubGroup");
    // }

    if (image.length > 0 && image.length > 10) {
      return toastMessage("You can upload a maximum of 10 images", "error", "coverImageUpdateSubGroup");
    }
    // if (image.some(img => !img.name && typeof img !== "string")) {
    //   return toastMessage("Please upload valid cover images", "error", "coverImageUpdateSubGroup");
    // }

    try {
      setLoading(true);
      const formData = new FormData();
      multipartDataHelper(
        formData,
        { ...inputData, attachments: image.map((data) => data?.file) },
        ["attachments"]
      );

      const { data } = await createFeedApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "createFeedHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <div className="create_group">
        <DashboardHeader title={"Groups"} />

        <div className="create_group_page">
          <div className="create_grp_Navbar">
            <nav>
              <ul className="_breadcrumb">
                <li className="__breadcrumb_group">
                  {/* <Link to={-1}>Groups </Link> */}
                  <Link to={-1} className="active">
                    <FaArrowLeft className="backarrow_grp_detail" />
                  </Link>
                </li>
                <li>
                  <span>Create Feed</span>
                </li>
              </ul>
            </nav>
          </div>

          <div className="upload_cover">
            <div className="slider_banner">
              <Slider {...settings}>
                {image &&
                  image?.length > 0 &&
                  image?.map((data) => (
                    <div className="upload_design_content">
                      <img
                        src={
                          (data?.file?.name &&
                            URL.createObjectURL(data?.file)) ||
                          upload_cover
                        }
                      />
                      <RxCross2 onClick={() => removeImageHandler(data?._id)} className="cross_btn" />
                    </div>
                  ))}
              </Slider>
            </div>
            <div className="upload_design">
              <label className="user_icon" htmlFor="file_picker">
                <div className="upload_design_content">
                  {/* {image &&
                    image?.length > 0 &&
                    image?.map((data) => (
                      <img
                        src={
                          (data?.file?.name &&
                            URL.createObjectURL(data?.file)) ||
                          upload_cover
                        }
                      />
                    ))} */}
                  <div className="upload_design_text">
                    <h3>Upload Cover</h3>
                    <p>(JPG, GIF, PNG. Max size of 800K)</p>
                  </div>
                </div>
                <input
                  type="file"
                  id="file_picker"
                  accept="image/*"
                  multiple
                  onChange={(e) =>
                    multipleImageHandler(e, setImage, "image", null)
                  }
                />
                <label htmlFor="profile_picture" className="edit-icon"></label>
              </label>
            </div>

            <div className="form-group form-group-top">
              <Input
                required
                label="Title"
                type="text"
                id="title"
                name="title"
                value={inputData?.title}
                onChange={handleChange}
                className="input form-control"
                placeholder="Enter Title"
              />
            </div>

            <div className="form-group textarea">
              <TextArea
                required
                label="Description"
                type="text"
                id="description"
                name="description"
                value={inputData?.description}
                onChange={handleChange}
                className="input form-control"
                placeholder="Write here..."
                rows="6"
              />
            </div>
          </div>
          <LoadingButton
            isDisabled={buttonDisabledButton}
            loading={loading}
            className={buttonDisabledButton ? "cstm_disabled_btn" : ''}
            onClick={createFeedHandler}>
            Create Feeds
            {/* {buttonDisabledButton ? <CiNoWaitingSign /> : " Create Feed"} */}
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

export default CreateFeeds;
